import React, { useContext, createElement } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, ShoppingCartIcon } from 'lucide-react';
import { CartContext } from '../layout/Header';
interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  image: string;
  rating: number;
  seller: string;
  discount?: number;
  isNew?: boolean;
}
const ProductCard = ({
  id,
  name,
  price,
  image,
  rating,
  seller,
  discount,
  isNew
}: ProductCardProps) => {
  // We need to create a mock CartContext since the real one is in Header
  // In a real app, you'd use a global state management solution like Context or Redux
  const addToCart = () => {
    // Find the Header component's exported CartContext
    const headerElement = document.querySelector('header');
    if (headerElement) {
      // Create a custom event to communicate with the Header component
      const addToCartEvent = new CustomEvent('addToCart', {
        detail: {
          id,
          name,
          price,
          image,
          quantity: 1
        }
      });
      headerElement.dispatchEvent(addToCartEvent);
      // Show a small notification
      const notification = document.createElement('div');
      notification.className = 'fixed bottom-4 right-4 bg-green-700 text-white px-4 py-2 rounded-md shadow-lg z-50';
      notification.textContent = `${name} added to cart!`;
      document.body.appendChild(notification);
      // Remove the notification after 3 seconds
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 3000);
    }
  };
  return <div className="bg-white rounded-xl overflow-hidden shadow hover:shadow-md transition duration-300 flex flex-col h-full" data-id="element-242">
      <Link to={`/product/${id}`} className="block relative" data-id="element-243">
        <img src={image} alt={name} className="w-full h-48 object-cover hover:opacity-90 transition duration-300" data-id="element-244" />
        {discount && <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-245">
            -{discount}%
          </span>}
        {isNew && <span className="absolute top-2 right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-246">
            NEW
          </span>}
      </Link>
      <div className="p-4 flex-grow flex flex-col" data-id="element-247">
        <Link to={`/product/${id}`} className="block" data-id="element-248">
          <h3 className="font-medium text-gray-800 mb-1 hover:text-green-600 transition duration-200" data-id="element-249">
            {name}
          </h3>
        </Link>
        <div className="text-sm text-gray-500 mb-2" data-id="element-250">by {seller}</div>
        <div className="flex items-center mb-3" data-id="element-251">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-252" />)}
          <span className="text-xs text-gray-500 ml-1" data-id="element-253">
            ({rating.toFixed(1)})
          </span>
        </div>
        <div className="mt-auto flex items-center justify-between" data-id="element-254">
          <div data-id="element-255">
            {discount ? <div className="flex items-center" data-id="element-256">
                <span className="font-semibold text-gray-800" data-id="element-257">
                  ${(price * (1 - discount / 100)).toFixed(2)}
                </span>
                <span className="text-gray-500 text-sm line-through ml-2" data-id="element-258">
                  ${price.toFixed(2)}
                </span>
              </div> : <span className="font-semibold text-gray-800" data-id="element-259">
                ${price.toFixed(2)}
              </span>}
          </div>
          <button className="p-2 rounded-full bg-green-50 hover:bg-green-100 text-green-600 transition duration-200" onClick={addToCart} data-id="element-260">
            <ShoppingCartIcon className="h-5 w-5" data-id="element-261" />
          </button>
        </div>
      </div>
    </div>;
};
export default ProductCard;